module.exports = __webpack_public_path__ + "img/left-leg_hover.247bb832.png";